import React, { memo } from "react";
import { TextField, InputAdornment, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiPhone from "./Input/MuiPhone";
import { formatWithCommas } from "../CandidateForm/RevenueSlider";

const RedAsterisk = styled("span")({
  color: "red",
});

const CustomNumberField = ({
  id,
  label,
  name,
  autoComplete,
  autoFocus,
  endAdornmentIcon: EndAdornmentIcon,
  formik,
  type = "text",
  loginPage = false,
  placeholder,
  numberFlag = false,
  required,
  ...props
}) => {
  const handlePhoneChange = (phone) => {
    formik?.setFieldValue(name, phone);
  };

  return (
    <>
      <MuiPhone
        required={required}
        label={label}
        name={name}
        placeholder={placeholder}
        value={formik?.values[name] || ""}
        onChange={handlePhoneChange}
        onBlur={formik?.handleBlur}
        error={formik?.touched[name] && Boolean(formik?.errors[name])}
        helperText={
          formik?.touched[name] && formik?.errors[name]
            ? formik.errors[name]
            : ""
        }
        {...props}
      />
    </>
  );
};

export default memo(CustomNumberField);


export const NumberField = ({
  id,
  label,
  name,
  autoComplete,
  autoFocus,
  endAdornmentIcon: EndAdornmentIcon,
  formik,
type="text",
  placeholder,
  numberFlag = false,
  ...props
}) => {
  const handleKeyPress = (event) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      ".",
    ];
    if (
      numberFlag &&
      !/[0-9.]/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    let numericalValue = inputValue.replace(/[^\d]/g, "");
    formik.setFieldValue(name, Number(numericalValue));
    // const hasLeadingSpace = /^\s/.test(inputValue);
    // if (hasLeadingSpace) return;
    // if (numberFlag && !/^\d*\.?\d{0,2}$/.test(inputValue)) return;
    // formik?.handleChange(e);
  };

  return (
    <>
      <Grid item xs={6}>
        <Typography variant="body1" fontSize={"14px"}>
          {label}
          <span style={{ color: "red" }}>*</span>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="outlined"
          fullWidth
          id={id}
          name={name}
          type={type}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          placeholder={placeholder}
          value={formatWithCommas(formik?.values[name])}
          onChange={handleChange}
          onBlur={formik?.handleBlur}
          error={formik?.touched[name] && Boolean(formik?.errors[name])}
          helperText={
            formik?.touched[name] && formik?.errors[name]
              ? formik.errors[name]
              : ""
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {EndAdornmentIcon && (
                  <EndAdornmentIcon style={{ fontSize: "18px" }} />
                )}
              </InputAdornment>
            ),
            style: {
              fontWeight: 300,
            },
            inputProps: {
              style: {
                padding: "8px 14px",
                fontSize: "14px",
                fontFamily: "Urbane-Light",
                textAlign:"end"
              },
              // onKeyDown: handleKeyPress,
            },
          }}
          {...props}
        />
      </Grid>
    </>
  );
};
